import { useCallback } from 'react';
import { BankType, InputNegotiationExtraInfo, InputNegotiationOption, InputNegotiationOptionAlternative, Negotiation, NegotiationType, useCreateNegotiationMutation } from '../generated/graphql';

export type NegotiationProps = {
  outDebtId: string;
  bank: BankType;
  negotiationOption: InputNegotiationOption;
  negotiationType: NegotiationType;
  alternative: InputNegotiationOptionAlternative;
  extraInfo: InputNegotiationExtraInfo;
};

export const useCreateNegotiationHelper = () => {
  const [ createNegotiationMutation ] = useCreateNegotiationMutation();

  const deepCopy = (value:any) => JSON.parse(JSON.stringify(value));

  const createNegotiation = useCallback((negotiation: NegotiationProps) => {
    const {
      outDebtId, alternative, bank, extraInfo, negotiationType, negotiationOption,
    } = negotiation;
    const deepAlternativeCopy: Negotiation['alternative'] = deepCopy(alternative);
    delete deepAlternativeCopy.__typename;

    const deepNegOptionCopy: Negotiation['negotiationOption'] = deepCopy(negotiationOption);
    deepNegOptionCopy.alternatives = negotiationOption.alternatives.map((alt) => {
      const deepCopyTemp = deepCopy(alt);
      delete deepCopyTemp.__typename;
      return deepCopyTemp;
    });
    delete deepNegOptionCopy.__typename;
    delete deepNegOptionCopy.settings?.__typename;

    const negotiationVars = {
      outDebtId: `${outDebtId}`,
      alternative: deepAlternativeCopy,
      bank,
      extraInfo,
      negotiationOption: deepNegOptionCopy,
      negotiationType,
    };

    return createNegotiationMutation({
      variables: negotiationVars,
      refetchQueries: [ 'GetOutDebts' ],
    });
  }, [ createNegotiationMutation ]);

  return [ createNegotiation ] as [ typeof createNegotiation ];
};
